import { Link } from 'react-router-dom';
import { ArrowRight, User, Truck, Building2 } from 'lucide-react';
import { motion } from 'framer-motion';
import { containerVariants, fadeUpVariants } from '../lib/motion';

export default function HostSection() {
  const partnerTypes = [
    { icon: User, title: 'Individuals', desc: 'Own EV assets and earn from active mobility operations.' },
    { icon: Truck, title: 'Fleet Owners', desc: 'Connect EV fleets with active mobility operations.' },
    { icon: Building2, title: 'Leasing Partners', desc: 'Deploy leased assets through the E Drives mobility network.' }
  ];

  return (
    <section className="section-pad bg-brand-lavender border-t border-b border-brand-dark/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          
          {/* Left Column: Slogan & Details */}
          <div className="lg:col-span-7 text-left">
            <span className="text-xs font-bold text-brand-green uppercase tracking-wider bg-brand-mint px-3 py-1 rounded-full border border-brand-dark/5">
              Asset Partnership
            </span>
            <h2 className="heading-display text-3xl md:text-5xl text-brand-dark mt-4 font-bold leading-tight">
              Your EV. Our Platform. <span className="italic font-light">Shared Opportunity.</span>
            </h2>
            <p className="mt-4 text-brand-dark/70 text-base md:text-lg max-w-2xl leading-relaxed">
              Bring electric vehicles onto the E Drives platform and participate in revenue generated through active mobility operations.
            </p>

            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <Link to="/host" className="btn-dark-pill inline-flex items-center gap-2 justify-center">
                Learn About Partnership <ArrowRight size={18} />
              </Link>
            </div>

            <p className="mt-4 text-xs font-semibold text-brand-green/80 uppercase tracking-wider">
              For Individuals · Fleet Owners · Leasing Partners
            </p>
          </div>

          {/* Right Column: Mini Partner Cards */}
          <div className="lg:col-span-5">
            <motion.div 
              variants={containerVariants(0.1)}
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              className="space-y-4"
            >
              {partnerTypes.map((p) => {
                const Icon = p.icon;
                return (
                  <motion.div 
                    key={p.title} 
                    variants={fadeUpVariants(15, 0.5)}
                    className="flex gap-4 items-center bg-white rounded-2xl p-5 border border-brand-dark/5 shadow-sm hover:shadow-md transition-shadow"
                  >
                    <div className="w-10 h-10 rounded-xl bg-brand-mint text-brand-dark flex items-center justify-center shrink-0 shadow-sm border border-brand-dark/5">
                      <Icon size={18} />
                    </div>
                    <div className="text-left">
                      <h4 className="font-bold text-sm text-brand-dark">{p.title}</h4>
                      <p className="text-xs text-brand-dark/65 mt-0.5 leading-relaxed">{p.desc}</p>
                    </div>
                  </motion.div>
                );
              })}
            </motion.div>
          </div>

        </div>
      </div>
    </section>
  );
}
